<template>
  <div class="bbs-show">
    <!-- <div class="toppicbox" v-if="info.cover||info.image">
      <img class="topimg" :src="info.cover" v-if="info.cover" @click="showImg(0,0)">
      <img class="topimg" :src="info.image[0]" v-else-if="info.image[0]" @click="showImg(0,1)">
    </div> -->
    <van-swipe class="toppicbox" :show-indicators="false" @change="changeimg">
      <van-swipe-item v-for="(item,index) in imglist" :key="'swipe_'+index">
        <img  class="topimg" v-lazy="item" @click="showImg(index,1)">
      </van-swipe-item>
    </van-swipe>
    <div class="piclength">{{imgindex}}/{{imgnum}}</div>
    <div class="toppicbox" v-if="info&&info.video">
      <video :src="info.video" height="100%" width="100%" controls="controls" controlslist="nodownload noremoteplayback" :poster="img.default">
      </video>
      <!-- <iframe
      style="z-index:1;"
      :src="info.video"
      allowfullscreen=""
      frameborder="0"
      height="250"
      width="100%"
      controlslist="nodownload noremoteplayback"
      >
    </iframe> -->
  </div>
  <div class="show" v-if="info">
    <van-row type="flex" justify="space-between" v-if="info.user">
      <van-col span="3" @click="goMy(info.user.id)">
        <div class="infohand_box">
          <img class="listhand" :src="info.user.headimg_url&&info.user.headimg_url.substring(0,5)=='https' ? info.user.headimg_url : img.avatar">
          <img class="infohand_border" :src="img.border_pic" v-if="info.user.auth.is_audit==1">
        </div>

      </van-col>

      <van-col class="ml-10 discenter" span="16" @click="goMy(info.user.id)">
        <div v-if="info.user.cars.id">
          <div class="membername">
            {{info.user.user_name}}
          </div>
          <div v-if="info.user.cars.id" class="sourtime" style="display: flex;align-items: center;">
            <img class="member_car" :src="img.member_car">
            {{info.user.cars.title}} 车主
          </div>
        <!-- <div v-if="info.user.intro" class="sourtime">
          {{info.user.intro}}
        </div> -->
      </div>
      <div v-else class="activename">
        {{info.user.user_name}}
      </div>
    </van-col>
    <van-col class="bintright" span="5">
      <van-button class="follow" v-if="info.user.is_follow==0" icon="plus" color="#3A3A3A" size="small" @click="follow()" :data-code="info.user.id">关 注</van-button>
      <van-button class="followd" v-if="info.user.is_follow==1&&info.user.id!=user.id" size="small"  @click="follow()" :data-code="info.user.id">已关注</van-button>
    </van-col>
  </van-row>
  <!-- <van-divider /> -->
  <h1 v-if="info.title">{{ info.title }}</h1>
  <p>{{ info.content }}</p>
  <div v-if="info.cover">
    <div v-for="(img, index) in info.image" :key="'img_' + index">
      <img class="img" v-if="index>0" v-lazy="img" @click="showImg(index,1)" />
    </div>
  </div>
  <div v-else>
    <div v-for="(img, index) in info.image" :key="'img_' + index">
      <img class="img" v-lazy="img" @click="showImg(index,1)" />
    </div>
  </div>
  <div class="tag" v-if="info.topics.length>0">
    <van-tag v-for="t in info.topics" :key="'tag_' + t.id + '_id_' + info.id" color="#F3F9FF" text-color="#728FC4" @click="binTopic(t.id)">#{{t.name}}#</van-tag>
  </div>
  <div class="tag f-12">
   <!-- <img class="location" :src="img.location"> -->
   <span class="c-gray">{{info.time_format}}</span>
   <!-- <span class="f-r c-gray" v-if="info.user.id==user.id" @click="delBbs()">删除</span> -->
 </div>
</div>
<div class="comments" hidden="true">
  <h2><span class="borderleft"></span> 其他作品</h2>
  <div class="comment">
    <van-row gutter="15">
      <van-col span="10">
        <img class="otherpic" v-lazy="img.pic">
      </van-col>
      <van-col class="listitle ellipsis-4" span="14">
        至臻进化 雅致入微 中大型豪华SUV新雷克萨斯RX / RX 450hL加长版开启预售至臻进化 雅致入微 中大型豪华SUV新雷克萨斯RX / RX 450hL加长版开启预售
      </van-col>
    </van-row>
  </div>
</div>
<!-- 评论 -->
<div class="comments" id="target">
  <h2><span class="borderleft"></span> 全部评论</h2>
  <van-list
  v-model="loading"
  :finished="finished"
  finished-text="已加载全部"
  :offset='50'
  @load="onLoad"
  >
  <div slot="loading" class="list-loading">
    <img :src="img.loading" />
  </div>
  <div class="comment">
    <van-row gutter="20" v-for="(comment,index) in comments" :key="'commment_' + comment.id">
     <van-col span="3" @click="goMy(comment.user.id)">
      <div class="infohand_box">
        <img class="avatar" :src="comment.user && comment.user.headimg_url&&comment.user.headimg_url.substring(0,5)=='https' ? comment.user.headimg_url : img.avatar" />
        <img class="infohand_border" :src="img.border_pic" v-if="comment.user.auth.is_audit==1">
      </div>
      
    </van-col>
    <van-col span="21">
      <div class="comm_name">
        <div style="flex: 1">
          {{ comment.user.user_name }}
          <div class="sourtime" style="display: flex;align-items: center;" v-if="comment.user.cars.id"><img class="member_car" :src="img.member_car">{{comment.user.cars.title}} 车主</div>
        </div>
        <span class="binbox">
          <img class="binpic" @click="setCommentPraise(index)" :src="comment.is_praise ? img.collect_have : img.collect">
          <span class="sourtime">{{ comment.praise_num }}</span>
        </span>
      </div>

      <p v-if="comment.content">
        <span v-if="comment.reuser">回复
          <span class="f-w">@{{ comment.reuser.user_name }}：</span>
        </span>{{ comment.content }}
      </p>
      <p class="time">{{ comment.create_time }}
        <span class="c-black" @click="replys(comment.id)"> · 回复</span>
        <span class="c-black" v-if="comment.comment_num>0">({{ comment.comment_num }})</span>
        <span v-if="comment.user.id==params.user_id" class="f-r" @click="delComment(comment.id,index)">删除</span>
        <span v-else class="f-r" @click="toTip">举报</span>
      </p>
    </van-col>
  </van-row>
</div>
</van-list>
</div>
<div @touchstart="touchstart()" class="postoverlay" v-show="overlay"></div>
<div class="postbottom" id="inputid">
  <van-row>
    <van-col :span="inputnum">
      <van-field v-model="value" @click="inputFocus()" :focus="inputfocus" placeholder="发表评论..." ref="inputTag" />
    </van-col>
    <van-col  v-if="inputshow" class="botright" span="10">
      <van-row>
        <van-col span="8" @click="goBotcom()"> 
          <span class="binbox">
            <img class="binpic" :src="img.comment">
            <span class="num" v-if="info.comment_num>0">{{info.comment_num}}</span>
          </span>
        </van-col>
        <van-col span="10">
          <span class="binbox" @click="Collect(info.is_praise)">
            <img class="binpic" :src="info.is_praise==1?img.collect_have:img.collect">
            <span class="num" v-if="info.praise_num>0">{{info.praise_num}}</span>
          </span>
        </van-col>
        <van-col v-if="info.is_audit==1" span="6">
          <span class="binbox" @click="outrelay(info.title,info.content,info.id,info.share_image)">
            <img class="binpic" :src="img.outrelay">
          </span>
        </van-col>
        <van-col v-else span="6">
          <span class="binbox">
            <img class="binpic" :src="img.outrelay">
          </span>
        </van-col>
      </van-row>
    </van-col>
    <van-col v-else span="5">
      <van-button color="#605C6B" size="small" @click="post()">发表</van-button>
    </van-col>
  </van-row>
</div>
<van-image-preview
v-model="showState"
:images="imagelist"
:startPosition="imgIndex"
lazyLoad
@change="changeImg"
>
<template v-slot:index>
  {{ imgIndex + 1 }}/{{ imagelist.length }}
</template>
</van-image-preview>
<van-action-sheet v-model="shareshow" :round="false" cancel-text="取消" @cancel="onCancel">
  <van-divider class="divider">分享</van-divider>
  <van-grid :border='false' :column-num="2">
    <!-- <van-grid-item :icon="img.inrelay" /> -->
    <van-grid-item :icon="img.friends" @click="toShare(2)" />
    <van-grid-item :icon="img.wechat" @click="toShare(1)" />
    <!-- <van-grid-item :icon="img.link" />
      <van-grid-item :icon="img.poster" /> -->
    </van-grid>
  </van-action-sheet>
</div>
</template>
<script>
  import bbs from '../../../api/bbs';
  import content from '../../../api/content';
  import member from '../../../api/member/memberinfo';
  import common from '../../../api/common';
  import { mapState } from 'vuex';
  import {Swipe, SwipeItem,List, Row, Col, Tab, Tabs, Tag, Button,Divider,Grid,GridItem,Field,Icon,Overlay,ImagePreview,Lazyload,ActionSheet} from "vant";
  export default {
    data () {
      return {
        value:'',
        oldvalue:'',
        inputshow:true,
        overlay:false,
        inputfocus:false,
        inputnum:14,
        rid:'',
        params: {
          page: 1,
          size: 4,
          user_id: 0
        },
        bbs_id: 0,
        loading: false,
        finished: false,
        info: '',
        comments: [],
        images:[],
        imglistL:[],
        imagelist:[],
        imgIndex:0,
        showState:false,
        shareshow:false,
        imgnum:'',
        imgindex:1,
        img: {
          avatar: require('../../../assets/img/lexus/default.png'),
          parise: require('../../../assets/img/parise.png'),
          parise_have: require('../../../assets/img/parise_have.png'),
          location: require('../../../assets/img/lexus/location.png'),
          pic:require('../../../assets/img/member/integral_bg.png'),
          loading: require('../../../assets/img/loading_lexus.gif'),
          friends: require('../../../assets/img/lexus/friends.png'),
          wechat: require('../../../assets/img/lexus/wechat.png'),
          sina: require('../../../assets/img/lexus/sina.png'),
          link: require('../../../assets/img/lexus/link.png'),
          poster: require('../../../assets/img/lexus/poster.png'),
          collect: require('../../../assets/img/lexus/collect.png'),
          collect_have: require('../../../assets/img/lexus/collect_have.png'),
          comment: require('../../../assets/img/lexus/comment.png'),
          inrelay: require('../../../assets/img/lexus/inrelay.png'),
          outrelay: require('../../../assets/img/lexus/outrelay.png'),
          friends: require('../../../assets/img/lexus/friends.png'),
          wechat: require('../../../assets/img/lexus/wechat.png'),
          link: require('../../../assets/img/lexus/link.png'),
          poster: require('../../../assets/img/lexus/poster.png'),
          default: require('../../../assets/img/default_lexus.png'),
          member_car: require('../../../assets/img/member_car.png'),
          border_pic:require('../../../assets/img/lexus/border.gif'),
        }
      }
    },
    
    computed: {
      ...mapState({
        user: state => state.param.user,
        source: state => state.param.source
      })
    },
    created () {
      this.$store.commit('param/show', false)
      this.$appService.isShowReturn({state: true})
      this.$appService.isTabbar({state: true})
      let id = this.$route.params.id
      this.weburl=process.env.VUE_APP_URL
      if(this.$util.isEmpty(id)) {
        this.$toast('帖子不存在')
        return false
      }

      this.bbs_id = id
      this.getInfo()
      
    },
    activated () {
      this.$appService.getToken(v => {
        if(v.token) {
          this.$store.dispatch('param/setToken', v.token)
        }
      })
      this.$store.commit('param/show', false)
      this.$appService.isShowReturn({state: true})
      this.$appService.isTabbar({state: true})
      this.$appService.getWinHeight(v => {
        console.log('getWinHeight=='+v.height)
        this.top_margin = v.height / 2
      })
    },
    methods: {
      getInfo () {
        let user_id = this.user ? this.user.id : 0
        var params={
          user_id: user_id,
          source:this.source
        }
        bbs.getShow(this.bbs_id, params).then(res => {
          if(res.data.state == 1) {
            this.info = res.data.data
            this.$util.title(res.data.data.title)
            var apppar={
              title:res.data.data.title
            }
            this.$appService.changeTitle(apppar)
            this.images = []
            for(let i of res.data.data.image) {
              this.images.push(i)
            }
            if (res.data.data.image) {
              this.imglist = res.data.data.image
            }
            if (res.data.data.cover) {
              this.imglist.unshift(res.data.data.cover)
            }
            this.imgnum=this.imglist.length
            if(res.data.data.title){
              document.title = res.data.data.title;
              document.querySelector('meta[name="keywords"]').setAttribute('content', res.data.data.title)
              document.querySelector('meta[name="description"]').setAttribute('content', res.data.data.title)
              var apppar={
                title:res.data.data.title
              }
              this.$appService.changeTitle(apppar)
            }else{
              var apppar={
                title:this.$route.meta.title
              }
              this.$appService.changeTitle(apppar)
            }
            var params={
              event_code: '帖子详情',
              event_id: this.info.id,
              title: this.info.title,
              value: '',
              path: '/Lexus/Bbs/LexusBbsShow.vue',
              user_id: this.user ? this.user.id : 0,
              source: this.source
            }
            common.BurialPoint(params).then(res => {
              if(res.data.state==1){

              }
            })
          }else{
            var params={
              event_code: '帖子详情',
              event_id: '',
              title: '',
              value: '',
              path: '/Lexus/Bbs/LexusBbsShow.vue',
              user_id: this.user ? this.user.id : 0,
              source: this.source
            }
            common.BurialPoint(params).then(res => {
              if(res.data.state==1){

              }
            })
          }
        })
      },
      changeimg(index){
        this.imgindex=index+1
      },
      showImg(key,type){
        this.imagelist =[]
        if(type==0){
          this.imagelist = [this.info.cover]
          this.imgIndex = key
          this.showState = true
        }else{
          this.imagelist = this.imglist
          this.imgIndex = key
          this.showState = true
        }
        
      },
      changeImg (index) {
        this.imgIndex = index
      },
      toTip() {
        this.$toast.success('举报成功')
      },
      inputFocus(){//点击输入框聚焦
        this.$appService.getToken(v => {
          if(v.token) {
            this.$store.dispatch('param/setToken', v.token)
            member.getMemberInfo({source:this.source}).then(res => {
              if(res.data.state == 1) {
                var binding_status=res.data.data.phone_binding_status.status
                var mobile=res.data.data.mobile
                if(mobile){
                  this.inputfocus=true
                  this.inputshow=false;
                  this.overlay=true;
                  this.inputnum=19;
                  setTimeout(() => {
                   var cc=document.getElementById('inputid');
                   cc.scrollIntoViewIfNeeded(true);
                 },500)
                }else{
                  this.$refs.inputTag.blur()
                  this.$dialog.confirm({
                    title:'温馨提示',
                    message: '根据国家《中华人民共和国网络安全法》规定，使用互联网服务需进行账号身份信息认证，还请您完成手机号码验证。验证后才能继续使用发布、评论等相关功能。感谢您的理解和支持！',
                    width:'80%',
                    messageAlign:'left',
                    confirmButtonText:'去绑定',
                  }).then(() => {
                   var params={
                    url:this.weburl+'/lexus/my/boundmobile?source='+this.source ,
                    isReturn: true 
                  }
                  this.$appService.openWebView(params)

                }).catch(() => {
                  this.inputfocus=true
                  this.inputshow=false;
                  this.overlay=true;
                  this.inputnum=19;
                  setTimeout(() => {
                   var cc=document.getElementById('inputid');
                   cc.scrollIntoViewIfNeeded(true);
                 },500)
                });
                
              }

            }
          })
          } else {
            var params={
              url:'',
              pagetype:0
            }
            this.$appService.needLogin(params)
          }
        })
        
      },
      replys(rid){//点击回复聚焦
        this.$appService.getToken(v => {
          if(v.token) {
            this.$store.dispatch('param/setToken', v.token)
            member.getMemberInfo({source:this.source}).then(res => {
              if(res.data.state == 1) {
               var binding_status=res.data.data.phone_binding_status.status
               var mobile=res.data.data.mobile
               if(mobile){
                this.inputshow=false;
                this.overlay=true;
                this.inputnum=19;
                this.inputfocus=true
                this.$refs.inputTag.focus()
                this.rid=rid
                setTimeout(() => {
                  var cc=document.getElementById('inputid');
                  cc.scrollIntoViewIfNeeded(true);
                },500);
              }else{
                this.$refs.inputTag.blur()
                this.$dialog.confirm({
                  title:'温馨提示',
                  message: '根据国家《中华人民共和国网络安全法》规定，使用互联网服务需进行账号身份信息认证，还请您完成手机号码验证。验证后才能继续使用发布、评论等相关功能。感谢您的理解和支持！',
                  width:'80%',
                  messageAlign:'left',
                  confirmButtonText:'去绑定',
                }).then(() => {
                 var params={
                  url:this.weburl+'/lexus/my/boundmobile?source='+this.source ,
                  isReturn: true 
                }
                this.$appService.openWebView(params)

              }).catch(() => {
                this.inputshow=false;
                this.overlay=true;
                this.inputnum=19;
                this.inputfocus=true
                this.$refs.inputTag.focus()
                this.rid=rid
                setTimeout(() => {
                  var cc=document.getElementById('inputid');
                  cc.scrollIntoViewIfNeeded(true);
                },500);
              });

            }
          }
        })
          } else {
            var params={
              url:'',
              pagetype:0
            }
            this.$appService.needLogin(params)
          }
        })
        
      },
      touchstart(){//检测触发遮罩层，失去焦点
        this.inputshow=true;
        this.overlay=false;
        this.$refs.inputTag.blur()
        this.inputnum=14;
        this.inputfocus=false
      },
      inputBlur(){//点击失去焦点
        setTimeout(() => {
          this.inputshow=true;
          this.inputnum=14;
        }, 1000);
        this.overlay=false;
        this.inputfocus=false
        this.$refs.inputTag.blur()
      },
      follow(e){
        this.$appService.getToken(v => {
          if(v.token) {
            this.$store.dispatch('param/setToken', v.token)
          } else {
            var params={
              url:'',
              pagetype:0
            }
            this.$appService.needLogin(params)
          }
        })
        let type = this.info.user.is_follow ? 2 : 1;
        content.Follow({follow_user_id: this.info.user.id, type: type,media_id: 6}).then(res => {
          if(res.data.state == 1) {
            if(type == 1) {
              this.info.user.is_follow=1
            } else {
              this.info.user.is_follow=0
            }
          }
        })
      },
      post(){
        let params={
          rid:this.rid,
          card_id:this.bbs_id,
          content:this.value
        }
        bbs.Comment(params).then(res => {
          if(res.data.state == 1) {
            this.inputshow=true;
            this.inputnum=14;
            this.overlay=false;
            this.inputfocus=false
            this.$refs.inputTag.blur()
            this.$toast.success('发表成功')
            this.value=''
            this.finished = false
            this.comments=[]
            this.params.page = 1
          }
        })
      },
      getCommentList(){
        this.params.user_id = this.user ? this.user.id : 0
        this.params.source = this.source
        bbs.getCommentList(this.bbs_id, this.params).then(res => {
          this.comments.push.apply(this.comments, res.data.data.data)
          this.params.page += 1
          this.loading = false
          if(res.data.data.data.length == 0) {
            this.finished = true
          }
        })
      },
      goBotcom(){//页面滚动到底部评论
        document.getElementById("target").scrollIntoView();
      },
      setCommentPraise(index){
        this.$appService.getToken(v => {
          if(v.token) {
            this.$store.dispatch('param/setToken', v.token)
          } else {
            var params={
              url:'',
              pagetype:0
            }
            this.$appService.needLogin(params)
          }
        })
        if(this.user) {
          let type = this.comments[index].is_praise ? 2 : 1;
          bbs.setCommentPraise({id: this.comments[index].id, type: type}).then(res => {
            if(res.data.state == 1) {
              if(type == 1) {
                this.comments[index].is_praise = 1
                this.comments[index].praise_num += 1
              } else {
                this.comments[index].is_praise = 0
                this.comments[index].praise_num -= 1
              }
            }
          })
        } else {
          this.$toast('请先登录')
          return false
        }
      },
      Collect(type){
        this.$appService.getToken(v => {
          if(v.token) {
            this.$store.dispatch('param/setToken', v.token)
          } else {
            var params={
              url:'',
              pagetype:0
            }
            this.$appService.needLogin(params)
          }
        })
        if(this.user) {
          if(type==1){
            var type=2
          }else{
            var type=1
          }
          bbs.setPraise({id: this.bbs_id, type: type}).then(res => {
            if(res.data.state == 1) {
              if(type == 1) {
                this.info.is_praise = 1
                this.info.praise_num += 1
              } else {
                this.info.is_praise = 0
                this.info.praise_num -= 1
              }
            }
          })
        } else {
          this.$toast('请先登录')
          return false
        }
      },
      delComment(id,index){
        this.$appService.getToken(v => {
          if(v.token) {
            this.$store.dispatch('param/setToken', v.token)
          } else {
            var params={
              url:'',
              pagetype:0
            }
            this.$appService.needLogin(params)
          }
        })
        this.$dialog.confirm({
          message: '确定要删除吗？'
        }).then(() => {
          bbs.delComment(id).then(res => {
            if(res.data.state == 1) {
              this.$toast.success('已删除')
              this.comments.splice(index,1);
            }
          })
        }).catch(() => {});
      },
      delBbs(){
        this.$dialog.confirm({
          message: '确定要删除吗？'
        }).then(() => {
          bbs.delBbs(this.bbs_id).then(res => {
            if(res.data.state == 1) {
              this.$toast.success('删除成功')
              setTimeout(() => {
                var params={
                  url:this.weburl+'/lexus/my/index?refresh=1&source='+this.source ,
                  isReturn: true 
                }
                this.$appService.openWebView(params)
              }, 1500);
            }
          })
        }).catch(() => {});
      },
      onCancel(){
        this.actionshow=false
      },
      outrelay(title,content,id,imageUrl){
        var user_id=this.user?this.user.id:0
        this.shareshow=true
        this.sharetitle=title
        this.sharecontent=content
        this.shareurl='/pages/articleinfo/articleinfo?scene='+id+'-'+user_id
        this.shareweburl=this.weburl+'/lexus/bbs/'+id+'?source='+this.source
        if(imageUrl){
          this.shareimageUrl=imageUrl
        }else{
          this.shareimageUrl='https://pic.motortime.com/logo/lexus_logo.png'
        }
      },
      toShare(type){
        if(type==1){
          var params={
            type:type,
            title:this.sharetitle,
            content:this.sharecontent,
            url:this.shareurl,
            imageUrl:this.shareimageUrl,
            weburl:this.shareweburl,
            wechatid:'gh_d2c493f1bc41'
          }
          this.shareshow=false
          this.$appService.shareContent(params)
        }else{
          this.$appService.getToken(v => {
            if(v.token) {
              var para={
                source:9,
                cid:this.bbs_id,
                user_id:this.user.id
              }
              bbs.getPoster(para).then(res => {
                if(res.data.state == 1) {
                  var params={
                    type:type,
                    title:this.sharetitle,
                    content:this.sharecontent,
                    url:this.shareurl,
                    imageUrl:res.data.data.share_url,
                    weburl:this.shareweburl,
                    wechatid:'gh_d2c493f1bc41'
                  }
                  this.shareshow=false
                  this.$appService.shareContent(params)
                }
              })
            }else{
              var params={
                url:'',
                pagetype:0
              }
              this.$appService.needLogin(params)
            }
          })
        }
      },
      goMy(id){
        var params={
          url:this.weburl+'/lexus/my/other/'+id+'?source='+this.source ,
          isReturn: true 
        }
        this.$appService.openWebView(params)
      },
      binTopic(id){
        this.$router.push({name: 'LexusTopicInfo',params:{id:id}})
      },
      onLoad() {

        setTimeout(() => {
          this.getCommentList()
        }, 500);
      }
    },
    components: {
      [Swipe.name]: Swipe,
      [SwipeItem.name]: SwipeItem,
      [Row.name]: Row,
      [Col.name]: Col,
      [List.name]: List,
      [Tab.name]: Tab,
      [Tabs.name]: Tabs,
      [Tag.name]: Tag,
      [Button.name]: Button,
      [Divider.name]:Divider,
      [Grid.name]:Grid,
      [GridItem.name]:GridItem,
      [Field.name]:Field,
      [Icon.name]:Icon,
      [Overlay.name]:Overlay,
      [ImagePreview.name]:ImagePreview,
      [Lazyload.name]:Lazyload,
      [ActionSheet.name]:ActionSheet
    }
  };
</script>

<style lang="scss">
.bbs-show {
  margin-bottom: 50px;
  background-color: #F0F0F0;
  .toppicbox{
    width: 100%;
    height: 250px;
    object-fit: cover;
  }
  .piclength{
    width: 30px;
    float: right;
    margin-right: 10px;
    margin-top: -25px;
    position: relative;
    font-size: 10px;
    color: #fff;
    background-color: #000000;
    opacity: 0.5;
    text-align: center;
  }
  .topimg{
    width: 100%;
    height: 250px;
    margin-bottom: 20px;
    object-fit: cover;
  }
  .img {
    width: 100%;
    display: block;
    margin-top: 10px;
  }
  .sourtime{
    font-size: 12px;
    color: #9A9A9A;
    vertical-align: middle;
  }
  .show {
    padding: 10px 0;
    overflow: hidden;
    background-color: #FFF;
    .listhand{
      width:40px;
      height:40px;
      border-radius: 1.5px;
    }
    .infohand_box{
      width:40px;
      height:40px;
      position: relative;
    }
    .infohand_border{
     width:40px;
     height:40px;
     position: absolute;
     left: 0;
   }
   .ml-10{
    margin-left: 10px;
  }
  .membername{
    font-size: 15px;
    font-weight: bold;
  }
  .activename{
    font-size: 14px;
    font-weight: bold;
    line-height: 3;
    color: #605C6B;
  }
  .van-row{
    padding: 0 10px;
  }
  .bintright {
    text-align:right;
    .van-button__icon{
      font-size: 10px;
    }
    .van-button__text{
      font-size: 11px;
    }
  }
  h1 {
    padding: 0 10px;
    margin-top: 20px;
    font-size: 16px;
    word-break:break-all;
  }
  p {
    padding: 0 10px;
    margin: 0;
    font-size: 14px;
    margin-top: 20px;
    line-height: 25px;
    word-break:break-all;
  }
  .van-tag{
    font-size: 12px;
    margin-right: 5px;
  }
  .location{
    width:12px;
    height:15px;
    margin-right:8px;
    vertical-align: middle;
  }
  .tip {
    text-align: right;
  }
  .tag{
    padding: 5px 10px;
  }
  .parise {
    text-align: center;
    margin-top: 10px;


    img {
      width: 15px;
      height: 14px;
      vertical-align: middle;
      margin: 0;
      margin-right: 7px;
    }
  }
  .divider{
    font-size: 13px;
    margin: 20px 80px;
  }
  .van-icon__image{
    width: 24px;
    height: 20px;
  }
}
.comments {
  background-color: #FFF;
  margin-top: 10px;

  h2 {
    font-size: 14px;
    font-weight: bold;
    padding: 15px 10px;
    border-bottom: 1px solid #EAEAEA;
    margin: 0;
  }
  .comment {
        // margin: 0 10px;
        overflow: hidden;

        .van-row {
          border-bottom: 1px solid #f8f8f8;
          padding: 10px;
        }
        .avatar {
         width: 40px;
         height: 40px;
         object-fit: cover;
         border-radius: 1.5px;
       }
       .infohand_box{
        width:40px;
        height:40px;
        position: relative;
      }
      .infohand_border{
       width:40px;
       height:40px;
       position: absolute;
       left: 0;
     }
     .comm_name {
      height: 40px;
      font-size: 14px;
      color:#605c6b; 
      display: flex;
      align-items: center;
      .binbox {
        color: #9A9A9A;
        font-size: 12px;
        float: right;
        font-weight: normal;

        img {
          width: 15px;
          height: 14px;
          margin-right: 11px;
          vertical-align: middle;
        }

      }
    }
    p {
      font-size: 13px;
      line-height: 1.4;

      .c-blue {
        font-style: normal;
      }
      &.time {
        font-size: 12px;
        color: #9A9A9A;

        span {
          margin-left: 5px;
        }
      }
    }
      // img {
        //   width: 280px;
        //   border-radius: 1.5px;
        // }
        .otherpic{
          width: 100%;
          height: 100px;
        }
        .listitle{
          font-size: 16px;
          font-weight:bold;
          line-height: 25px;
        }
      }
      .borderleft{
        margin-right: 10px;
        border-left: 3px solid #3A3A3A;
      }
    }
    .sharelist{
      width: 20%;
      text-align: center;
      display: flex;
      .picquan{
        width: 20px;
        height: 20px;
      }
      .picapp{
        width: 24px;
        height: 20px;
      }
    }
    a {
      color: #000000;
    }
    .follow{
      vertical-align: super;
    }
    .followd{
      color: #728FC4;
      background: #F3F9FF;
      border-color: #F3F9FF;
    }
    .van-button--small{
      height: 24px;
      padding: 0 8px;
      line-height: 20px;
      border-radius: 1px;
      vertical-align: middle;
    }
    .van-popup{
      .van-action-sheet__cancel::before{
        height: 1px;
      }
      .divider{
        margin: 20px 80px;
      }
    }
  }
</style>
